import { makeStyles } from '@material-ui/styles';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Label, MoneyAmountValue, Space } from '@/components';

const useStyles = makeStyles(() => ({
  money: {
    fontWeight: 500,
    justifyItems: 'flex-start',
    fontSize: '36px',
    lineHeight: '36px',
  },
  currency: {
    fontSize: '15px',
    lineHeight: '22px',
  },
}));

export interface WalletValueProps {
  'data-test'?: string;
  value?: number;
  options?: ReactNode[];
  hideTitle?: boolean;
}

const WalletValue: React.FC<WalletValueProps> = ({ hideTitle = false, value, options, 'data-test': dataTest }) => {
  const classes = useStyles();
  return (
    <Space direction="vertical" size={2}>
      {!hideTitle && (
        <Label data-test={dataTest && `${dataTest}-title`}>
          <FormattedMessage id="withdrawal.components.wallet.value.sum.title" />
        </Label>
      )}
      <Space direction="vertical" size={3}>
        <MoneyAmountValue
          data-test={dataTest && `${dataTest}-amount`}
          className={classes.money}
          currencyClassName={classes.currency}
          value={value}
          withCurrency
        />
        {(options?.length || 0) > 0 && <Space size={2}>{options}</Space>}
      </Space>
    </Space>
  );
};
export default WalletValue;
